import React from 'react'

function PetCategoryIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="160" height="80" viewBox="0 0 160 80" {...props}>
      <defs>
        <clipPath id="PetCategoryIcon">
          <path
            fill="none"
            stroke="#707070"
            strokeLinejoin="round"
            strokeWidth="1"
            d="M0 0H160V80H0z"
            data-name="Rectangle 10093"
            transform="translate(-19716 -14264)"
          ></path>
        </clipPath>
      </defs>
      <g clipPath="url(#clip-path)" data-name="Mask Group 798" transform="translate(19716 14264)">
        <g data-name="Group 58760" transform="translate(-19697.539 -14262.535)">
          <path
            fill="#f3f6f6"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            d="M38.471 70.758l20.916-20.381 4.763 22.676H50.896"
            data-name="Path 91489"
          ></path>
          <path
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeWidth="1"
            d="M60.327 67.307l-4.185.327"
            data-name="Path 91490"
          ></path>
          <path
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            d="M25.614 66.252s-2.394 2.58-8.6 3.71c-4.406.8-10.17-3.548-9.937-2.837.171.518 4.132 5.862 9.937 5.927 5.611.063 11.58-1.78 11.144-2.078"
            data-name="Path 91491"
          ></path>
          <path
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            d="M44.213 65.917c-3.984 2.955 5.715-4.462 11.594-10.329 3.773-3.762 7.885-8.036 9.5-12.792 2.537-7.5.67-11.62-1.488-16-1.078-2.2-1.734-4.855-3.1-7.522a4.106 4.106 0 001.432-3.155c.367.436 2.5 1.259 3.346.517 1.27-1.4 1.389-3.78 1.791-6.541.3-2.026 1.07-4.4-.258-6.3-.605-.877-9.039-5.6-11.08-3.055-1.816-1.268-9.084-.756-13.543 1.142-1.273-1.4-3.383.184-5.906 1.913-2.035 1.39-4.533 2.851-4.639 4.026-.277 3.105 4.012 9.29 6.881 11.093.773.486 2.141-2.149 2.18-1.977.73 2.871 2.2 3.029 2.2 3.029s.465 1.091-1.844 5.448-1.66 7.006-1.66 7.006-9.646 9.049-11.389 21.033c-6.158 9.688-2.8 18.148 0 19.6h20.5c2.867-.854 2.412-3.479 0-4.459s-3.859.605-8.2.542c-.141 0-1.65.023-2.354 0"
            data-name="Path 91492"
          ></path>
          <path
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeWidth="1"
            d="M40.851 17.251a33.8 33.8 0 01.138-11.457"
            data-name="Path 91493"
          ></path>
          <path
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeWidth="1"
            d="M55.135 22.119s-3.035 1.475-5.609 0"
            data-name="Path 91494"
          ></path>
          <path
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeWidth="1"
            d="M56.455 13.306c-1.337-2.178-7.389-3.257-9.762.683"
            data-name="Path 91495"
          ></path>
          <path
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeWidth="1"
            d="M56.313 68.525a5.426 5.426 0 00-3.45.912"
            data-name="Path 91496"
          ></path>
          <path
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeWidth="1"
            d="M62.153 16.008S62.152 7.313 59.218 4.5"
            data-name="Path 91498"
          ></path>
          <path
            fill="#263238"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            d="M56.025 16.39a3.83 3.83 0 01-3.919 3.691 4.285 4.285 0 01-4.379-3.235 5.287 5.287 0 004.04-.63c1.833 1.166 4.258.174 4.258.174z"
            data-name="Path 91499"
          ></path>
          <g
            fill="#263238"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            data-name="Ellipse 1943"
            transform="translate(44.243 7.412)"
          >
            <ellipse cx="1.447" cy="1.294" stroke="none" rx="1.447" ry="1.294"></ellipse>
            <ellipse cx="1.447" cy="1.294" fill="none" rx="0.947" ry="0.794"></ellipse>
          </g>
          <g
            fill="#263238"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            data-name="Ellipse 1944"
            transform="translate(55.094 6.765)"
          >
            <ellipse cx="1.447" cy="1.294" stroke="none" rx="1.447" ry="1.294"></ellipse>
            <ellipse cx="1.447" cy="1.294" fill="none" rx="0.947" ry="0.794"></ellipse>
          </g>
          <path
            fill="#fff"
            d="M-26.856-3.579l-5.008 1.563.53-1.794L-18.4-34.394s.607 8.977 3.258 11.346c1.893 1.691 5.323-.012 7.02-1.236l-4.678 6.11-14.47 15.163"
            data-name="Path 91500"
            transform="translate(70.365 72.286)"
          ></path>
          <path
            fill="#ecf0f1"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            d="M40.441 24.835s1.323 2.683 6.876 5.978 11.595 7.017 13.495 8.076c.876.486 2.255-2.866 2.966-6.564a22.332 22.332 0 00-.4-8.412s-.4-1.372-.726-1.041c-.792.808-4.573 5.128-9.59 5.241-5.458.122-8.7-3.195-11.752-4.486a10.329 10.329 0 00-.87 1.209"
            data-name="Path 91501"
          ></path>
          <path
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            d="M52.135 37.64c-1.908 14.347 3.709 29.638 4.006 30.618 4.478.282 3.663 4.613 2.282 4.613h-6.949c-.115-.784-4.112-10.45-7.071-20.349-.992-3.316-1.387-7.323-2.123-10.216-.55-2.158-1.58-6.1-1.58-6.1"
            data-name="Path 91502"
          ></path>
          <path
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            d="M38.218 69.072a23.512 23.512 0 006.237-6.411c3.266-5.444 4.986-13.132-6.032-12.4"
            data-name="Path 91503"
          ></path>
          <path
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            d="M28.228 73.051h22.451c2.863-.852 2.412-3.479 0-4.457s-7.162.973-12.9.729"
            data-name="Path 91504"
          ></path>
          <path
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            d="M63.503 46.99c.8 8.228 1.883 16.027 2.427 19.382.063.393.145.842.184.983 4.478.306 4.136 5.7 2.755 5.7h-7a181.488 181.488 0 01-4.226-18.86"
            data-name="Path 91505"
          ></path>
          <path
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeWidth="1"
            d="M43.166 68.92l4.74-5.173"
            data-name="Path 91507"
          ></path>
          <path
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeWidth="1"
            d="M53.293 57.92c4.834-3.579 9.69-10.358 9.69-10.358"
            data-name="Path 91508"
          ></path>
          <path
            fill="#263238"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            d="M54.539 11.956c.64.579-1.81 2.6-2.731 2.58s-3.6-1.685-2.851-2.372a5.03 5.03 0 012.62-.792 5.453 5.453 0 012.962.584z"
            data-name="Path 91509"
          ></path>
          <path
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeWidth="1"
            d="M51.736 14.619v2.049"
            data-name="Path 91510"
          ></path>
          <path
            fill="#f3f6f6"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            d="M54.498 19.322a5.006 5.006 0 01-2.324.758 6.005 6.005 0 01-2.447-.6 2.7 2.7 0 012.447-1.969c1.846-.039 2.075 1.426 2.324 1.811z"
            data-name="Path 91511"
          ></path>
          <path
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            d="M57.284 15.532a4.635 4.635 0 01-5.478.555c-2.93 1.513-4.615.613-5.509-.2"
            data-name="Path 91512"
          ></path>
        </g>
        <g transform="translate(-19713.672 -14260.419)">
          <g transform="translate(7.607 70.746)">
            <path fill="#263238" d="M140.064.726h-140v-1h140z" data-name="Line 254"></path>
          </g>
        </g>
        <g transform="translate(-19632.291 -14252.054)">
          <path
            fill="#ecf0f1"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            d="M36.06 51.094s3.5 2.372 8.453 0 2.528-8.123-.194-11.317-4.082-6.571-3.207-10.131 5.151-3.923 7.385-3.468 4.665 1.826 4.18 4.653-2.915 1.926-4.665 1.37-3.6-.548-3.6 1.284 3.886 5.475 4.955 9.583.39 8.031-3.3 10.4a9.431 9.431 0 01-10.591-.456c-2.619-1.918.584-1.918.584-1.918z"
            data-name="Path 86294"
          ></path>
          <path
            fill="#ecf0f1"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            d="M22.063 7.203l-8 1.1a17.527 17.527 0 00-4.686-2.826c-2.147-.686-3.7-2.342-4.153-1.065a14.166 14.166 0 00.6 6.648 11.207 11.207 0 002.616 2.153s-1.511 5.443-.387 7.7a4.884 4.884 0 003.209 2.147s-2.827 7.256-3 12.124-.166 7.923-.166 7.923-4.858-1.045-4.577 4.2 7.916 10.068 7.916 10.068-4.939.656-5.636 2.153 2.291 2.43 5.443 1.7a57.184 57.184 0 0110.13-.818c2.808-.094 13.471 2.283 15.832 1.8s1.069-2.645-.061-3.422-3.576-.454-3.576-.454 6.836-4.173 7.26-9.419-4.781-5.81-4.781-5.81.112-8.009-2.855-14.033-3.334-6.478-3.334-6.478 3.676-3.407 3.179-5.9-3.375-7.338-3.375-7.338.991-1.122.67-4.046A14.57 14.57 0 0028.649.07a.963.963 0 00-1.187.383c-.5.7-2.523 2.146-3.528 3.556a26.415 26.415 0 00-1.871 3.194z"
            data-name="Path 86296"
          ></path>
          <path
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            d="M37.138 58.781a8.495 8.495 0 00-3.072-.662c-1.019.169-3.13 2.847-3.133 3.376 2.615.84 4.281 1.13 6.266.726 2.362-.482 1.07-2.658-.061-3.44z"
            data-name="Path 86298"
          ></path>
          <path
            fill="#f3f6f6"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            d="M52.242 27.672a8.22 8.22 0 00-4.207-1.545 16.36 16.36 0 00-1.307 2.851 11.273 11.273 0 00-.488 2.758c.66.187 3.452 1.427 5.559.849 2.506-.689 1.978-3.553.443-4.913z"
            data-name="Path 91536"
          ></path>
          <path
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            d="M10.219 57.559c-1.509.334-3.95 1.037-4.424 2.179-.7 1.669 2.291 2.72 5.443 1.907 1.042-.272 2.193-.582 3.371-.88a12.371 12.371 0 00-4.39-3.206z"
            data-name="Path 86300"
          ></path>
          <path
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            d="M5.419 4.119a.843.843 0 00-.194.328 14.262 14.262 0 00.6 6.682 11.219 11.219 0 002.617 2.164c.552-.122 3.726-1.3 3.658-3.057S9.93 6.923 8.558 6.349a9.816 9.816 0 01-2.844-2.32z"
            data-name="Path 86313"
          ></path>
          <path
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            d="M29.617 8.852a6.464 6.464 0 00.736-1.39 7.825 7.825 0 00-.018-1.841A12.951 12.951 0 0028.653.734a1.007 1.007 0 00-1.187.357 3.945 3.945 0 01-.506.508l.084.085s-2.79 4.3-2.628 5.393 1.459 1.823 2.847 2.085 1.857.214 2.354-.31z"
            data-name="Path 86315"
          ></path>
          <path
            fill="#ecf0f1"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            d="M8.354 34.215c-.376 3.624 4.525 18.83 5.031 21.014s1.019 3.932 1.019 3.932-1.333.559-1.431 1.644.748 1.68 3.163 1.5 3.132-1.111 3.225-1.912-.875-7.7-.784-12.7c.06-3.292-1.224-10.776-2.673-16.761"
            data-name="Path 86317"
          ></path>
          <path
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            d="M16.136 62.365c2.416-.175 3.132-1.077 3.225-1.853a21.667 21.667 0 00-.173-2.366 11.577 11.577 0 00-5.062.206c.166.6.278.961.278.961s-1.333.542-1.431 1.594.747 1.633 3.163 1.458z"
            data-name="Path 86319"
          ></path>
          <path
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            d="M34.817 33.52c.228 3.658-5.606 19.947-6.189 22.128s-1.16 3.928-1.16 3.928 1.313.606 1.368 1.712-.792 1.257-3.2 1-3.108-.807-3.172-1.612a123.091 123.091 0 013.581-19.22 45.867 45.867 0 001.536-11.387"
            data-name="Path 86321"
          ></path>
          <path
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            d="M25.633 62.512c-2.407-.247-3.091-1.171-3.154-1.945a11.309 11.309 0 01.141-1.464c0-.032.058-.439.119-.895a11.738 11.738 0 015.053.36c-.189.591-.314.949-.314.949s1.313.583 1.367 1.647-.805 1.596-3.212 1.348z"
            data-name="Path 86323"
          ></path>
          <path
            fill="#263238"
            d="M574.492 168.395s-1.53-.5-1.752.509.981 1.215 1.907 1.476c.754-.269 2.008-.545 1.638-1.54s-1.793-.445-1.793-.445z"
            data-name="Path 86583"
            transform="translate(-553.848 -151.955)"
          ></path>
          <path
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            d="M16.717 19.282c1.546 2.839 4.089-.317 4.089-.317s2.35 2.394 3.859-.368"
            data-name="Path 86584"
          ></path>
          <path
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeWidth="1"
            d="M26.195 12.127a3.146 3.146 0 00-2.877-1.145"
            data-name="Path 86585"
          ></path>
          <path
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeWidth="1"
            d="M13.528 12.461a4.112 4.112 0 013.091-1.789"
            data-name="Path 86586"
          ></path>
          <path
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeWidth="1"
            d="M14.029 14.553a2.974 2.974 0 013.359-.231"
            data-name="Path 86587"
          ></path>
          <path
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeWidth="1"
            d="M23.254 14.221c1.954-1.034 2.978-.656 3.707.015"
            data-name="Path 86588"
          ></path>
          <path
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeWidth="1"
            d="M30.809 17.209l-4.051.657"
            data-name="Path 86590"
          ></path>
          <path
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeWidth="1"
            d="M10.403 18.486l4.051.657"
            data-name="Path 86593"
          ></path>
          <path
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeWidth="1"
            d="M29.618 15.01l-3.328 1.87"
            data-name="Path 86591"
          ></path>
          <path
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeWidth="1"
            d="M11.59 16.288l3.11 1.745"
            data-name="Path 86592"
          ></path>
          <path
            fill="#263238"
            d="M-.225 1.966l.2-1.609h.292C.335.4 5.7 4.888 10.052 4.647 14.5 4.4 18.21.018 18.249 0L19 1.341s-4.95 5.427-8.948 5.622S-.043 2.074-.225 1.966z"
            data-name="Path 91529"
            transform="translate(11.267 22.238)"
          ></path>
          <g fill="#f3f6f6" strokeLinejoin="round" data-name="Path 91529">
            <path
              d="M1.73 4.561c-.916 0-1.662-.728-1.662-1.622 0-.894.746-1.622 1.662-1.622.916 0 1.662.728 1.662 1.622 0 .894-.746 1.622-1.662 1.622z"
              transform="translate(20.094 28.062)"
            ></path>
            <path
              fill="#263238"
              d="M1.73 1.817c-.64 0-1.162.504-1.162 1.122 0 .619.521 1.122 1.162 1.122.64 0 1.162-.503 1.162-1.122 0-.618-.521-1.122-1.162-1.122m0-1c1.194 0 2.162.95 2.162 2.122S2.924 5.061 1.73 5.061s-2.162-.95-2.162-2.122S.536.817 1.73.817z"
              transform="translate(20.094 28.062)"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default PetCategoryIcon
